import { useState, useEffect } from "react";

export function useOnlineStatus() {
  // Default to true — navigator.onLine is unreliable in iOS/Android simulators
  // and some corporate proxies. Trust the browser's online/offline events instead.
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return isOnline;
}
